var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-indicator-box"},[_c('div',{staticClass:"title-box-info"},[_c('div',{staticClass:"sign-box"},[_c('span',[_vm._v(_vm._s(_vm.step))])]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }